import { PagesEnum } from '~/utils/route-config';

interface LinksWithTo {
    links: Array<{
        to: string;
    }>;
}

/**
 * Removes the HDE link from top-nav and footer link models when the Country row
 * has `ShowHDENavLink` disabled for the current market.
 */
export const removeHDEFromNavLinks = <T extends LinksWithTo>(
    links: T,
    showHDENavLink: boolean,
): T => {
    if (showHDENavLink) {
        return links;
    }

    return filterOutHDELink(links);
};

const filterOutHDELink = <T extends LinksWithTo>(links: T): T => {
    return {
        ...links,
        links: links.links.filter(
            (link) => link.to !== PagesEnum.HOME_DESIGN_EVENING,
        ),
    } as T;
};
